const circleColumns = [
  {
    label: 'Name',
    value: 'name',
    textId: 'fleetadmin.circle.table.name',
    disabled: true,
  },
  {
    label: 'Type',
    value: 'circleType',
    textId: 'fleetadmin.circle.table.type',
    disabled: false,
  },
  {
    label: 'Code',
    value: 'circleCode',
    textId: 'fleetadmin.circle.table.code',
    disabled: false,
  },
  {
    label: 'Created at',
    value: 'created',
    textId: 'fleetadmin.circle.table.createdat',
    disabled: false,
  },
  {
    label: 'Last modified at',
    value: 'lastModifiedAt',
    textId: 'fleetadmin.circle.table.lastmodifiedat',
    disabled: false,
  },
  {
    label: 'Last modified by',
    value: 'lastModifiedBy',
    textId: 'fleetadmin.circle.table.lastmodifiedby',
    disabled: false,
  },
];

export const defaultSelectedCircleColumns = circleColumns.map(
  (circleColumn) => circleColumn.value
);

export default circleColumns;
